import constants from 'constants/index'

const selectSourceOptions = (options, anotherSource) => {
  if (!anotherSource) {
    return options.filter(
      (option) => option.id !== constants.dataProcess.ANOTHER_SOURCE,
    )
  }
  return options
}

export default selectSourceOptions
